<template>
    <div class="q-ma-sm">
    <iframe
        frameborder="0" height="600px" width="100%"
        src="https://docs.google.com/document/d/e/2PACX-1vT-WIVPWlFeP5zw8ITivOnHeiRGFEJuFEM4CZqKOn0UyCEHHy4n1lVdx06WdhmREg/pub?embedded=true"
    >
    </iframe>
    </div>
</template>
<script>
export default {
    setup() { 
    },
}
</script>
